const formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'ከአንድ ሴኮንድ በታች',
    other: 'ከ{{count}} ሴኮንድ በታች',
  },

  xSeconds: {
    one: '1 ሴኮንድ',
    other: '{{count}} ሴኮንድ',
  },

  halfAMinute: 'ግማሽ ደቂቃ',

  lessThanXMinutes: {
    one: 'ከአንድ ደቂቃ በታች',
    other: 'ከ {{count}} ደቂቃ በታች',
  },

  xMinutes: {
    one: '1 ደቂቃ',
    other: '{{count}} ደቂቃ',
  },

  aboutXHours: {
    one: '1 ሰዓት ገደማ',
    other: '{{count}} ሰዓት ገደማ',
  },

  xHours: {
    one: '1 ሰዓት',
    other: '{{count}} ሰዓት',
  },

  xDays: {
    one: '1 ቀን',
    other: '{{count}} ቀን',
  },

  aboutXMonths: {
    one: '1 ወር ገደማ',
    other: '{{count}} ወር ገደማ',
  },

  xMonths: {
    one: '1 ወር',
    other: '{{count}} ወር',
  },

  aboutXYears: {
    one: '1 ዓመት ገደማ',
    other: '{{count}} ዓመት ገደማ',
  },

  xYears: {
    one: '1 ዓመት',
    other: '{{count}} ዓመት',
  },

  overXYears: {
    one: 'ከ 1 ዓመት በላይ',
    other: 'ከ {{count}} ዓመት በላይ',
  },

  almostXYears: {
    one: '1 ዓመት ገደማ',
    other: '{{count}} ዓመት ገደማ',
  },
};

export default function formatDistance(token, count, options) {
  options = options || {};

  let result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'በ ' + result + ' ቀናት ውስጥ';
    }

    return 'ከ' + result + ' ቀናት በፊት';
  }

  return result;
}
